import React, { ReactNode } from 'react';
import styled from '@emotion/styled';

const Text = styled.a`
  color: #e4e4e4;
  font-size: 1rem;
  padding-top: 15px;
  font-weight: 600;
  cursor: pointer;
  &:hover {
    border-bottom: 2px solid #e4e4e4;
  }

  @media (max-width: 500px) {
    display: block;
    width: 100%;
    margin-bottom: 15px;
    padding-left: 25px;
  }
`;

interface Props {
  children: ReactNode;
}

export const DisabledTextButton = (props: Props) => {
  return <Text>{props.children}</Text>;
};

export default DisabledTextButton;
